interface UsersListPanelFooterProps {
  visibleCount: number;
  totalInScope: number;
  /** Imported rows in scope: people who cannot sign in yet. */
  importedCount: number;
}

/** Bottom row of the Users list panel — count summary. Pagination was
 *  removed; the table scrolls internally instead. */
export default function UsersListPanelFooter({
  visibleCount,
  totalInScope,
  importedCount,
}: UsersListPanelFooterProps) {
  return (
    <div className="py-2 px-[18px] border-t border-stone-200 dark:border-stone-800 bg-white dark:bg-[#1a1f1c] flex items-center text-[11.5px] text-stone-500 dark:text-stone-400">
      Showing <strong className="text-bark-800 dark:text-[#e8ece9] mx-1">{visibleCount}</strong> of{' '}
      {totalInScope}
      {importedCount > 0 && (
        <span className="ml-2 text-clay-600 font-semibold">
          · {importedCount} imported {importedCount === 1 ? 'needs' : 'need'} an invite
        </span>
      )}
    </div>
  );
}
